import { ServiceExecutionSequenceModel } from 'app/app-model/diagnostic-service/service-execution-sequence.model';

export class SecurityAccessModel {
    name: string;
    flashDatabaseKeyFilePath: string;
    timeoutHandling: string;
    requestSeedSequence: ServiceExecutionSequenceModel;
    sendKeySequence: ServiceExecutionSequenceModel;
}